import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { Cart } from '@asm/features/quick-order/models/cart.model';

@Injectable({ providedIn: 'root' })
export class CartRepository extends RepositoryBase<Cart> {
  protected readonly KEY_PATH = 'cart';

  getActive(): Observable<Cart | null> {
    return this.getAll().pipe(map(carts => carts[0] ?? null));
  }
}
